import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';

@AutoUnsubscribe()
@Component({
    selector: 'app-job-sent-to-queue',
    templateUrl: './job-sent-to-queue.component.html',
    styles: []
})
export class JobSentToQueueComponent implements OnInit, OnDestroy {

    dialogTitle = 'Job Sent to Queue';
    dialogContent = 'The report has been sent to the queue.';

    constructor(
        @Inject(MAT_DIALOG_DATA) private data: any,
        public jobSentToQueueDialogRef: MatDialogRef<JobSentToQueueComponent>
    ) { }

    ngOnInit() {
        if (this.data) {
            if (this.data.dialogTitle) {
                this.dialogTitle = this.data.dialogTitle;
            }
            if (this.data.dialogContent) {
                this.dialogContent = this.data.dialogContent;
            }
        }
    }

    ngOnDestroy() {
    }

    cancelClick() {
        this.jobSentToQueueDialogRef.close('Close was clicked');
    }
}
